import { ArrowUpDown } from 'lucide-react';

const columns = ['Committee Name', 'Committee Type', 'Schedule', 'Role', 'Member', 'Cadence', 'Status', 'Action'];

const CommitteeTableHeader = () => {
  return (
    <div className="pt-4">
      <div className="committee-table-header-row ">
        {columns.map((column) => (
          <div key={column} className={`committee-table-header-cell ${column === 'Action' ? 'justify-center' : ''}`}>
            <span>{column}</span>

            {column !== 'Action' && <ArrowUpDown size={10} strokeWidth={2} className="committee-table-header-icon" />}
          </div>
        ))}
      </div>
    </div>
  );
};

export default CommitteeTableHeader;
